import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog, MatTab } from '@angular/material';
// import { TreeTableModule } from 'primeng/treetable';
// import { NodeService } from './nodeservice'; 
// import { TreeNode } from 'primeng/api';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

// import { RepAcctComponent } from '../rep-acct/rep-acct.component';

@Component({
  selector: 'app-fin-position',
  templateUrl: './fin-position.component.html',
  styleUrls: ['./fin-position.component.css']
})
export class FinPositionComponent implements OnInit {

  public menu_item_id = '120';
  
  model = { 'fromDate': new Date(), 'toDate': new Date(), 'rep_type': 'is', 'level_id': '', 
    'title': '' };
  repTypeList = [{ 'rep_type': 'is', 'type_name': 'قائمة الدخل', 'type_name_en': 'Income Statement' },
    { 'rep_type': 'bs', 'type_name': 'المركز المالي', 'type_name_en': 'Financial Position' }];

  levelList = [];
  // [{ 'level_id': 4, 'level_name': 'المستوى الرابع (الحسابات الفرعية)' },
  // { 'level_id': 3, 'level_name': 'المستوى الثالث (الحسابات الرئيسية)' }];

  private dp = [];
  displayedColumns = ['acct_name', 'amount'];
  displayedColumns2 = ['acct_name', 'amount'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  from_date;
  to_date;
  mainAcctList = [];

  // tableData: TreeNode[] = []; 
  // cols: any[] = []; 

  // repAcctDialogRef: MatDialogRef<RepAcctComponent>;
  Report_Type;
  // Income_Statement; Financial_Position; From_Date; To_Date; Level;
  From_Date_Msg; To_Date_Msg;
  // private nodeService: NodeService
  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);
    
    translate.get('Report_Type').subscribe((res: string) => {
      this.Report_Type = res;
    });

    // translate.get('Income_Statement').subscribe((res: string) => {
    //   this.Income_Statement = res;
    // });

    // translate.get('Financial_Position').subscribe((res: string) => {
    //   this.Financial_Position = res;
    // });

    // translate.get('From_Date').subscribe((res: string) => {
    //   this.From_Date = res;
    // });

    // translate.get('To_Date').subscribe((res: string) => {
    //   this.To_Date = res;
    // });
    
    // translate.get('Level').subscribe((res: string) => {
    //   this.Level = res;
    // });
    
    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });
  }

  ngOnInit() {
    this.from_date = (this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
      this.model['fromDate'].getDate() + ' 00:00:00');
    this.to_date = (this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
      this.model['toDate'].getDate() + ' 23:59:59');

    // get levels
    // let query = "SELECT MIN(`acct_level`) AS `from_level`, MAX(`acct_level`) AS `to_level` FROM `sub_acct`";
    // let obj = { cmd: 'getList', query: query };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();

    //     let from_level = Number(data.data['list'][0]['from_level']);
    //     let to_level = Number(data.data['list'][0]['to_level']); 
    //     this.model['level_id'] = data.data['list'][0]['from_level'];

    //     for (; from_level <= to_level; from_level++) {
    //       this.levelList.push({ 'level_id': from_level, 'level_name': 'المستوى ' + from_level, 
    //         'level_name_en': 'Level ' + from_level });
    //     }
    //   });
  }

  search() {
    this.dp = [];

    for (let index = 0; index < this.repTypeList.length; index++) {
      if (this.repTypeList[index].rep_type == this.model['rep_type']) {
        if (this.applicationConstants.user_lang == 'ar')
          this.model['title'] = this.repTypeList[index]['type_name'];
        else 
          this.model['title'] = this.repTypeList[index]['type_name_en'];
        break;
      }
    }

    // if (this.model['fromDate'] == undefined || this.model['fromDate'].toString() == '') {
    //   alert(this.From_Date_Msg);
    //   return;
    // }

    // if (this.model['toDate'] == undefined || this.model['toDate'].toString() == '') {
    //   alert(this.To_Date_Msg);
    //   return;
    // }

    // this.from_date = (this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
    //   this.model['fromDate'].getDate() + ' 00:00:00');
    // this.to_date = (this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
    //   this.model['toDate'].getDate() + ' 23:59:59');

    let obj = { cmd: 'getFinPos', rep_type: this.model['rep_type'] };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        // console.log(data);
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') 
          this.dp = data.status['msg'][0]['list'];
        else
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  // showAcctRep(row) {
  //   // this.model['level_id'] == '4' && row.acct_number != '0'
  //   if (row.is_leaf == '1') {
  //     row.from_date = this.from_date;
  //     row.to_date = this.to_date;
  //     // console.log(row.acct_number);
  //     this.repAcctDialogRef = this.dialog.open(RepAcctComponent, {
  //       hasBackdrop: false,
  //       data: row,
  //       width: "90%",
  //       height: "95%",
  //     });
  //     this.repAcctDialogRef
  //       .afterClosed()
  //       .subscribe(result => {
  //       });
  //   }
  // }

  print() {
    // get the report type
    let rep_type = {};
    for (let index = 0; index < this.repTypeList.length; index++) {
      if (this.repTypeList[index].rep_type == this.model['rep_type']) {
        rep_type = this.repTypeList[index];
        break;
      }
    }

    let html_data = '<table cellpadding="8" cellspacing="0"><tr><td> ' + this.Report_Type + ': ';
    if (this.applicationConstants.user_lang == 'ar') {
      html_data += rep_type['type_name'];
      // this.model['title'] = rep_type['type_name'];
    }
    else {
      html_data += rep_type['type_name_en'];
      // this.model['title'] = rep_type['type_name_en'];
    }
    html_data += '</td></tr></table>';
    //   this.from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td><td width="33%"> ' + 
    //   this.Level + ': ' + this.Level + " " + this.model['level_id'] + '</td></tr></table>';

    let table = (document.getElementById('is_table2') as HTMLTableElement);
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
